'use client'

import React from 'react'

import storyStyles from '../../styles/global/story_styles.js'
import { TopStory } from '../../types'
import Body from './Body'
import { StyledStoryContentContainer } from './StoryContent.styles'

type StoryContentProps = {
  story: TopStory
}

const StoryContent = ({ story }: StoryContentProps) => {
  return (
    <>
      <StyledStoryContentContainer direction='column' gap={['1rem', '1.25rem']} width='100%'>
        <Body body={story.body} content={story.content} />
      </StyledStoryContentContainer>
      <style jsx> {storyStyles}</style>
    </>
  )
}

export default StoryContent
